<template>
  <div :class="{ 'site-preview': true, 'site-preview-popup': isPopupOpened }">
    <base-site-loader type="load" v-if="isLoading" />
    <template v-else>
      <site-preview-controls />
      <site-preview-popup v-model="isPopupOpened" />
    </template>
    <div class="iframe-wr">
      <iframe
        scrolling="auto"
        class="iframe"
        :src="iframeSrc"
        @load="handleLoad"
        @error="handleError"
      />
    </div>
  </div>
</template>

<script>
import SitePreviewControls from '@/components/SitePreviewControls/SitePreviewControls';
import SitePreviewPopup from '@/components/SitePreviewPopup/SitePreviewPopup';
import { captureException } from '@sentry/browser';
import store from '@/store';

export default {
  components: {
    SitePreviewControls,
    SitePreviewPopup,
  },
  data() {
    return {
      isLoading: true,
      isPopupOpened: true,
    };
  },
  computed: {
    iframeSrc() {
      return store.autoLoginUrl;
    },
  },
  methods: {
    handleLoad() {
      this.isLoading = false;
    },
    handleError(error) {
      captureException(error);
    },
  },
  mounted() {
    if (!store.autoLoginUrl) {
      this.$router.push('/');
    }
    document.body.classList.add('site-preview');
  },
  destroyed() {
    document.body.classList.remove('site-preview');
  },
};
</script>

<style scoped src="./sitePreview.css"></style>
